import type { ReactNode } from "react";
import { cn } from "@/utils/cn";

/**
 * KPI tile matching the wireframe's dashboard cards (e.g. "312 autos online",
 * "₹16K commission · 10%" highlighted in gold).
 */
export function StatCard({
  value,
  label,
  sublabel,
  highlight,
  icon,
  className,
}: {
  value: ReactNode;
  label: string;
  sublabel?: string;
  highlight?: boolean;
  icon?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col gap-1 rounded-xl border p-4",
        highlight
          ? "border-gold-600/40 bg-gold-100"
          : "border-border bg-cream-50 shadow-card",
        className,
      )}
    >
      <div className="flex items-center justify-between">
        <span className="text-2xl font-semibold tracking-tight text-ink">{value}</span>
        {icon && <span className="text-ink-faint">{icon}</span>}
      </div>
      <span className="text-sm text-ink-muted">{label}</span>
      {sublabel && <span className="text-xs text-ink-faint">{sublabel}</span>}
    </div>
  );
}
